<mat-card class="container">
  <mat-card-content>
    @if (gymUUID) {
      <gymfinder-class-booking-config [classBookingConfig]="classBookingConfig">
      </gymfinder-class-booking-config>

      <gymfinder-geofence-config [(geofence)]="geofence">
      </gymfinder-geofence-config>
    }
    <mat-card class="tan-account-creation-config-card">
      <mat-toolbar class="toolbar-subtitle">
        <mat-toolbar-row>TAN account creation</mat-toolbar-row>
      </mat-toolbar>
      <mat-card-content>
        <mat-checkbox
          [ngModel]="tanAccountCreationEnabled"
          (ngModelChange)="tanAccountCreationEnabled = $event"
          [ngModelOptions]="{ standalone: true }">
          <b>Show TAN QR after check-in</b>
        </mat-checkbox>
        <p>
          For gyms using TAN-based account creation. A provider access pass
          takes priority. This setting is independent of class booking and MMS
          member account creation.
        </p>
        @if (!gymUUID) {
          <p>
            Displaying a TAN QR at check-in requires a gym identity that
            check-in can resolve. Synchronize the gym to provide a Gym UUID.
          </p>
        }
      </mat-card-content>
    </mat-card>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  </mat-card-actions>
</mat-card>
